import { gql } from "@apollo/client";

const schema = {
  list: {
    name: "role",
    serviceName: "labadmin",
    query: gql`
      query role($ids: [String]) {
        role(ids: $ids) {
          total
          last_page
          data {
            id
            title
          }
        }
      }
    `,
  },
  delete: {
    name: "deleteRole",
    serviceName: "admin",
    query: gql`
      mutation deleteRole($ids: [String]!) {
        deleteRole(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  assignment: {
    name: "role",
    serviceName: "labadmin",
    query: gql`
      query role($ids: [String]) {
        role(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
